import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 0;\n  opacity: 0.8;\n  transition: opacity 0.15s;\n\n  &:hover {\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { FREEDOM_RED_DARK } from '../../utilities/constants';
var STYLES = css(_templateObject());
var DEFAULT_SIZE = '48px';
export default function CloseButton(props) {
  var size = props.size || DEFAULT_SIZE;
  return jsx("button", {
    type: "button",
    title: props.title || 'Close',
    onClick: props.handleClick,
    className: props.className,
    css: STYLES,
    style: {
      width: size,
      height: size,
      overflow: 'visible'
    }
  }, jsx("svg", {
    viewBox: "0 0 24 24",
    overflow: "visible",
    "aria-hidden": "true",
    width: size,
    height: size
  }, jsx("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    stroke: "none",
    fill: FREEDOM_RED_DARK
  }), jsx("g", {
    transform: "rotate(45, 12, 12)"
  }, jsx("line", {
    x1: "12",
    y1: "4",
    x2: "12",
    y2: "20",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "4",
    y1: "12",
    x2: "20",
    y2: "12",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "3",
    strokeLinecap: "round"
  }))));
}